import { ProductKey, VALID_PRODUCT_KEYS } from "@/constants/products";

/**
 * Validate if a string is a valid ProductKey.
 *
 * @param value - The value to validate
 * @returns True if the value is a valid ProductKey, false otherwise
 */
export function isValidProductKey(value: string | null): value is ProductKey {
  return value !== null && VALID_PRODUCT_KEYS.includes(value as ProductKey);
}

/**
 * Get the default product from available products, preferring "redteam" if available.
 *
 * @param availableProducts - List of available product names
 * @returns The default ProductKey, or null if no products are available
 */
export function getDefaultProduct(availableProducts: string[]): ProductKey | null {
  if (availableProducts.length === 0) {
    return null;
  }
  if (availableProducts.includes("redteam")) {
    return "redteam";
  }
  // Validate first product is a valid ProductKey
  const firstProduct = availableProducts[0];
  return isValidProductKey(firstProduct) ? firstProduct : null;
}
